import React, { useEffect } from 'react'
import { Flex } from '@ui'
import { Icon, Button, Tag } from '@runeffective/evo-design-system'
import MapFilter from 'components/MapFilter/MapFilter'
import AssetFilter from 'components/AssetFilter/AssetFilter'
import api, { IAssetTag } from '@api'

const FinderMapFilters = ({
  mapViewSettings,
  isBookDeskPage,
  isBookMeetingRoomPage,
  updateMapViewSettings,
  assetFilterSettings,
  updateAssetFilterSettings,
}: {
  isBookDeskPage: boolean
  isBookMeetingRoomPage: boolean
  mapViewSettings: any
  updateMapViewSettings: any
  assetFilterSettings: []
  updateAssetFilterSettings: any
}) => {
  const assets = useAssetTags()

  return (
    <Flex align="center" justify="space-between">
      {mapViewSettings && !isBookDeskPage && !isBookMeetingRoomPage && (
        <MapFilter
          updateMapViewSettings={updateMapViewSettings}
          mapViewSettings={mapViewSettings}
          triggerElement={
            <Button aria-label="Map Filter" layout="borderless" isFloatingActionButton size="small">
              <Icon iconName="filter" iconStyle="fal" size="sm" />
            </Button>
          }
        />
      )}
      {(isBookDeskPage || isBookMeetingRoomPage) && (
        <AssetFilter
          updateAssetFilter={updateAssetFilterSettings}
          assetFilterSettings={assetFilterSettings}
          items={assets}
          triggerElement={
            <Button
              aria-label="Asset Filter"
              layout="borderless"
              isFloatingActionButton
              onClick={function noRefCheck() {}}
              size="small">
              <Icon iconName="custom-default-asset-light" iconStyle="fal" size="sm" />
              {assetFilterSettings.length > 0 && (
                <Tag
                  title={assetFilterSettings.length.toString()}
                  isRemovable
                  onRemove={() => updateAssetFilterSettings('', [], false, true)}
                  removeButtonProps={{
                    'aria-label': 'tag',
                  }}
                />
              )}
            </Button>
          }
        />
      )}
    </Flex>
  )
}

export default FinderMapFilters

let persistedState: IAssetTag[] = []

export function useAssetTags(): IAssetTag[] {
  const [assetTags, setAssetTags] = React.useState<IAssetTag[]>(persistedState)

  useEffect(() => {
    api.company.fetchAssetTags().then((assetTags: any) => {
      const {
        data: {
          viewer: {
            company: {
              assetTags: { edges },
            },
          },
        },
      } = assetTags
      const tags = edges.map(({ node }: any) => {
        return { id: node.id, name: node.name }
      })
      setAssetTags(tags)
    })
  }, [])

  useEffect(() => {
    // Cache initial list
    if (!persistedState.length && assetTags.length) {
      persistedState = assetTags
    }
  })

  return assetTags
}
